module.exports = __webpack_public_path__ + "static/media/dashboard-phone.7db25102.svg";